import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=273b6297&"
import script from "./Design.vue?vue&type=script&lang=js&"
export * from "./Design.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports